import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { BaseModal, ListItem } from '../../shared'
import { JobOwnershipsComponent } from './job-ownerships.component'

@Component({
    templateUrl: './add-job.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class AddJobComponent extends BaseModal implements OnInit {
    faSpinner = faSpinner
    jobMap: ListItem<string>[] = []
    selectedJob: any
    templatesMap: ListItem<string>[] = []
    selectedTemplate!: string
    parentComponent!: JobOwnershipsComponent

    readonly title = 'Add Job Ownerships from Template'

    ngOnInit() {
        // We need to get a list of job options that don't include ones we already have ownerships for.
        const jobMap = [] as ListItem<string>[]
        for (const job of this.parentComponent.allJobs) {
            const match = this.parentComponent.jobMap.find(x => x.value == job.id)
            if (!match) {
                jobMap.push(new ListItem(job.id, job.id + ' ' + job.name))
            }
        }
        this.jobMap = jobMap
        this.selectedJob = this.jobMap[0].value
        this.templatesMap = this.services.data.jobOwnershipTemplates.items.map(x => new ListItem(x.id, x.name))
        this.selectedTemplate = this.templatesMap[0].value
    }

    protected onSave(resolveSave: (result?: any) => void, rejectSave: (reason?: any) => void) {
        const observable = this.services.data.put('api/JobOwnership/AddJobOwnershipsFromTemplate', {
            jobId: this.selectedJob,
            templateId: this.selectedTemplate,
        })
        observable.subscribe({
            next: () => {
                resolveSave(this.selectedJob)
            },
            error: errorResult => {
                rejectSave(errorResult)
            },
        })
    }
}
